import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class OpponentsService {
    constructor(private http: HttpClient) { }

    getOpponentsList() {
        return this.http.get('assets/demo/data/opponent.json')
            .toPromise()
            .then(res => res)
            .then(data => data);
    }
    getOpponentsListWithoutAuth(query): Observable<any> {
        return this.http.get(USER_API + "career/v1?" + query);
    }

    getOpponentsDetails() {
        return this.http.get('assets/demo/data/career.json')
            .toPromise()
            .then(res => res)
            .then(data => data);
    }

    updateOpponents(id, careerData): Observable<any> {
        return this.http.put(USER_API + 'career/' + id, careerData);
    }

    addOpponents(careerData): Observable<any> {
        return this.http.post(USER_API + 'career', careerData);
    }
    getOpponents(id,query): Observable<any> {
        return this.http.get(USER_API+"tournamentdraw/compareskills"+id,query);
      }
}